import { BasicLayout } from 'components/layouts/BasicLayout';
import { PageViewAnalytics } from 'components/PageViewAnalytics';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import { Provider } from 'react-redux';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from '@doda/pc/src/redux/store';
import { NewJobListScreen } from './screens/NewJobListScreen';
import { getServerSideProps } from './getServerSideProps';

const NewJobList = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const {
    featuredJobs,
    totalJobCount,
    occupationInitialCountList,
    areaInitialCountList,
    industryInitialCountList,
    initialState,
  } = props;
  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <BasicLayout selectedNavItem={HEADER_NAV_MENU.SEARCH}>
        <PageViewAnalytics pageName="新着求人一覧画面" />
        <NewJobListScreen
          featuredJobs={featuredJobs}
          totalJobCount={totalJobCount}
          occupationInitialCountList={occupationInitialCountList}
          areaInitialCountList={areaInitialCountList}
          industryInitialCountList={industryInitialCountList}
        />
      </BasicLayout>
    </Provider>
  );
};

export { getServerSideProps };

export default NewJobList;
